import {
  getFilterValue as getDateFilterValue,
  getPresetLabelWithValue as getDatePresetLabel,
} from "./datePresetUtils";

/**
 * Checks if a filter has a dynamic value.
 * @param {Object} filter - Filter object with { type, value }
 * @returns {boolean} - True if the filter has a dynamic value, false otherwise
 */
export function hasDynamicValue(filter) {
  return filter?.value?.dynamic;
}

/**
 * Resolves a filter value to its actual value.
 * Handles dynamic values and returns static values as-is.
 *
 * @param {Object} filter - Filter object with { type, value }
 * @returns {*} - Resolved filter value
 */
const dynamicValueResolvers = {
  date: getDateFilterValue,
};
export function resolveDynamicFilterValue(filter) {
  if (hasDynamicValue(filter)) {
    if (!(filter.type in dynamicValueResolvers)) {
      return filter.value;
    }
    return dynamicValueResolvers[filter.type](filter.value);
  }
  return filter.value;
}

/**
 * Gets the display label for a dynamic value based on filter type.
 * Generic function that routes to type-specific label resolvers.
 * @param {Object} filter - Filter object with { type, value }
 * @returns {string} - Translated label or empty string
 */
const dynamicLabelResolvers = {
  date: getDatePresetLabel,
};
export function getDynamicLabel(filter) {
  if (!hasDynamicValue(filter)) {
    return "";
  }

  if (!(filter.type in dynamicLabelResolvers)) {
    return "";
  }
  return dynamicLabelResolvers[filter.type](filter.value);
}
